function nl4SerializeAddons(form, serialized, bulb) {
  if (!form) return serialized;
  const original = new URLSearchParams(serialized);
  const mainId = original.get('id');
  if (!mainId || original.has('selling_plan')) return serialized;
  const value = Number(form.querySelector('[name="quantity"]')?.value || 1);
  const quantity = Number.isSafeInteger(value) && value > 0 ? value : 1;
  const items = new Map();
  const add = item => {
    if (item && /^\d+$/.test(item.id || '') && String(item.id) !== String(mainId) && Number.isSafeInteger(item.quantity) && item.quantity > 0) {
      const id = String(item.id);
      items.set(id, (items.get(id) || 0) + item.quantity);
    }
  };
  if (bulb?.checkbox?.checked && bulb.isConnected) add({ id: bulb.dataset.bulbId, quantity: quantity * Number(bulb.dataset.bulbCount) });
  form.querySelectorAll('nl4-track-choice').forEach(choice => add(choice.selectedItem));
  if (!items.size) return serialized;
  const params = new URLSearchParams();
  for (const [key, value] of original) {
    if (key === 'quantity') continue;
    if (key === 'id') params.append('items[0][id]', value);
    else if (key.startsWith('properties[')) params.append('items[0][properties]' + key.slice('properties'.length), value);
    else params.append(key, value);
  }
  params.append('items[0][quantity]', quantity);
  let index = 1;
  for (const [id, count] of items) {
    params.append(`items[${index}][id]`, id);
    params.append(`items[${index}][quantity]`, count);
    index += 1;
  }
  return params.toString();
}

if (!customElements.get('nl4-bulb-choice')) {
  class NL4BulbChoice extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.checkbox = this.querySelector('[data-bulb-opt-in]');
      if (!this.form || !this.checkbox) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('change', () => this.update(), options);
      this.form.addEventListener('input', () => this.update(), options);
      this.form.addEventListener('change', () => this.update(), options);
      this.form.addEventListener('submit', () => this.update(), options);
      this.observer = new MutationObserver(() => this.update());
      const variantBlock = this.form.querySelector('[data-update-block="variant-id-main"]');
      if (variantBlock) this.observer.observe(variantBlock, { childList: true, subtree: true, attributes: true });
      this.querySelector('.nl4-bulb-choice__control').hidden = false;
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.form?.classList.remove('nl4-bulbs-selected');
    }
    get quantity() {
      const value = Number(this.form.querySelector('[name="quantity"]')?.value || 1);
      return Number.isSafeInteger(value) && value > 0 ? value : 1;
    }
    update() {
      if (!this.form || !this.checkbox) {
        this.form?.classList.toggle('nl4-bulbs-selected', Array.from(this.form.querySelectorAll('nl4-track-choice')).some(choice => choice.selectedItem));
        return;
      }
      const quantity = this.quantity * Number(this.dataset.bulbCount);
      const amount = quantity * Number(this.dataset.unitPrice) / 100;
      const price = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency }).format(amount);
      this.querySelector('[data-bulb-quantity]').textContent = this.dataset.quantityText.replace('[count]', quantity);
      this.querySelector('[data-bulb-subtotal]').textContent = this.dataset.subtotalText.replace('[price]', price);
      this.querySelector('.nl4-bulb-choice__hint').hidden = !this.checkbox.checked;
      this.form.classList.toggle('nl4-bulbs-selected', this.checkbox.checked || Array.from(this.form.querySelectorAll('nl4-track-choice')).some(choice => choice.selectedItem));
    }
    serialize(serialized) {
      return nl4SerializeAddons(this.form, serialized, this);
    }
  }
  customElements.define('nl4-bulb-choice', NL4BulbChoice);
}


if (!customElements.get('nl4-accessory-cart')) {
  class NL4AccessoryCart extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.querySelectorAll('[data-accessory-add], [data-accessory-options]').forEach(node => { node.hidden = false; });
      this.addEventListener('change', event => {
        const select = event.target.closest('[data-accessory-variant]');
        if (!select || !this.contains(select)) return;
        const row = select.closest('[data-accessory-row]');
        const option = select.selectedOptions[0];
        if (!row || !option) return;
        const button = row.querySelector('[data-accessory-add]');
        if (button) {
          button.dataset.accessoryAdd = option.value;
          button.disabled = option.dataset.available !== 'true';
        }
        row.querySelector('[data-accessory-details]').href = option.dataset.url;
        row.querySelector('[data-accessory-price]').textContent = option.dataset.price;
        const imageLink = row.querySelector('[data-accessory-image-link]');
        const image = imageLink?.querySelector('img');
        if (imageLink) imageLink.href = option.dataset.url;
        if (image && option.dataset.image) {
          image.removeAttribute('srcset');
          image.src = option.dataset.image;
        }
      }, { signal: this.controller.signal });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-accessory-add]');
        if (!button || !this.contains(button)) return;
        event.preventDefault();
        event.stopPropagation();
        this.add(button);
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
    async add(button) {
      if (this.busy || button.disabled) return;
      const row = button.closest('[data-accessory-row]');
      const select = row?.querySelector('[data-accessory-variant]');
      const quantityInput = row?.querySelector('[data-accessory-quantity]');
      const id = select ? select.value : button.dataset.accessoryAdd;
      const quantity = quantityInput ? Number(quantityInput.value) : 1;
      if (quantityInput && !quantityInput.reportValidity()) return;
      if (!/^\d+$/.test(id || '') || !Number.isSafeInteger(quantity) || quantity < 1 || quantity > 99) return;
      this.busy = true;
      const controls = Array.from(this.querySelectorAll('[data-accessory-add], [data-accessory-variant], [data-accessory-quantity]'));
      const disabledBefore = controls.map(control => control.disabled);
      const status = this.querySelector('[data-accessory-status]');
      const cartLink = this.querySelector('[data-accessory-cart-link]');
      controls.forEach(item => { item.disabled = true; });
      button.setAttribute('aria-busy', 'true');
      status.textContent = '';
      cartLink.hidden = true;
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity }] })
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) {
          throw new Error(typeof result.description === 'string' ? result.description : this.dataset.errorText);
        }
        status.textContent = this.dataset.addedText;
        cartLink.hidden = false;
        try { await this.refreshCart(); } catch { }
      } catch (error) {
        status.textContent = error.message || this.dataset.errorText;
      } finally {
        this.busy = false;
        controls.forEach((item, index) => { item.disabled = disabledBefore[index]; });
        button.removeAttribute('aria-busy');
      }
    }
    async refreshCart() {
      const response = await fetch(this.dataset.sectionUrl, { credentials: 'same-origin' });
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextForm = html.getElementById('AjaxCartForm');
      const nextSubtotal = html.getElementById('AjaxCartSubtotal');
      const form = document.getElementById('AjaxCartForm');
      const subtotal = document.getElementById('AjaxCartSubtotal');
      if (!nextForm || !nextSubtotal || !form || !subtotal) return;
      form.innerHTML = nextForm.innerHTML;
      subtotal.innerHTML = nextSubtotal.innerHTML;
      form.ajaxifyCartItems?.();
      const count = form.querySelector('[data-cart-count]')?.textContent;
      const total = form.querySelector('[data-cart-total]')?.textContent;
      if (count !== undefined) document.querySelectorAll('[data-header-cart-count]').forEach(node => { node.textContent = count; });
      if (total !== undefined) document.querySelectorAll('[data-header-cart-total]').forEach(node => { node.textContent = total; });
      document.getElementById('site-cart-sidebar')?.show?.();
    }
  }
  customElements.define('nl4-accessory-cart', NL4AccessoryCart);
}



if (!customElements.get('nl4-track-choice')) {
  class NL4TrackChoice extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.select = this.querySelector('[data-track-variant]');
      this.checkbox = this.querySelector('[data-track-opt-in]');
      this.quantityInput = this.querySelector('[data-track-quantity]');
      if (!this.form || !this.select || !this.checkbox || !this.quantityInput) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('change', () => this.update(), options);
      this.addEventListener('input', () => this.update(), options);
      this.form.addEventListener('submit', event => {
        if (this.checkbox.checked && !this.quantityInput.reportValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { capture: true, signal: this.controller.signal });
      this.querySelector('[data-track-control]').hidden = false;
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
    serialize(serialized) {
      return nl4SerializeAddons(this.form, serialized, this.form?.querySelector('nl4-bulb-choice'));
    }
    get selectedItem() {
      const option = this.select?.selectedOptions[0];
      const quantity = Number(this.quantityInput?.value);
      if (!this.checkbox?.checked || option?.dataset.available !== 'true' || !Number.isSafeInteger(quantity) || quantity < 1 || quantity > 99) return null;
      return { id: option.value, quantity };
    }
    update() {
      const option = this.select.selectedOptions[0];
      if (!option) return;
      this.checkbox.disabled = option.dataset.available !== 'true';
      if (this.checkbox.disabled) this.checkbox.checked = false;
      this.quantityInput.disabled = !this.checkbox.checked;
      this.querySelectorAll('[data-track-link]').forEach(link => { link.href = option.dataset.url; });
      const image = this.querySelector('.nl4-bulb-choice__product img');
      if (image && option.dataset.image) {
        image.removeAttribute('srcset');
        image.src = option.dataset.image;
      }
      const title = this.querySelector('[data-track-title]');
      if (title && option.dataset.label) title.textContent = option.dataset.label;
      this.querySelector('[data-track-price]').textContent = option.dataset.price;
      this.querySelector('[data-track-sku]').textContent = option.dataset.sku;
      const item = this.selectedItem;
      const subtotal = this.querySelector('[data-track-subtotal]');
      subtotal.hidden = !item;
      if (item) {
        const price = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency }).format(Number(option.dataset.unitPrice) * item.quantity / 100);
        subtotal.textContent = this.dataset.subtotalText.replace('[price]', price);
      }
      this.querySelector('[data-track-hint]').hidden = !item;
      const builder = this.closest('.nl4-track-builder');
      if (builder) {
        let selected = 0;
        const total = Array.from(builder.querySelectorAll('nl4-track-choice')).reduce((sum, choice) => {
          const part = choice.selectedItem;
          if (!part) return sum;
          selected += 1;
          return sum + Number(choice.select.selectedOptions[0].dataset.unitPrice) * part.quantity;
        }, 0);
        const summary = builder.querySelector('[data-builder-subtotal]');
        if (summary) {
          summary.hidden = selected === 0;
          const price = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency }).format(total / 100);
          summary.textContent = builder.dataset.summaryText.replace('[price]', price);
        }
      }
      this.form.dispatchEvent(new CustomEvent('nl4:track-change'));
      const bulb = this.form.querySelector('nl4-bulb-choice');
      if (bulb) bulb.update?.();
      else this.form.classList.toggle('nl4-bulbs-selected', Array.from(this.form.querySelectorAll('nl4-track-choice')).some(choice => choice.selectedItem));
    }
  }
  customElements.define('nl4-track-choice', NL4TrackChoice);
}





if (!customElements.get('nl-track-shopping-list')) {
  class NLTrackShoppingList extends HTMLElement {
    connectedCallback(){
      if(this.ready)return;
      this.form=this.closest('form');if(!this.form)return;
      try{this.main=JSON.parse(this.querySelector('[data-track-list-variants]').textContent);}catch{return;}
      this.ready=true;this.controller=new AbortController();
      const share=this.querySelector('[data-track-list-action="share"]');
      if(share)share.hidden=typeof navigator.share!=='function';
      this.addEventListener('click',event=>{
        const button=event.target.closest('[data-track-list-action]');
        if(button&&this.contains(button))this.listAction(button.dataset.trackListAction);
      },{signal:this.controller.signal});
      const update=()=>this.update();
      for(const type of ['input','change','nl4:track-change'])this.form.addEventListener(type,update,{signal:this.controller.signal});
      this.observer=new MutationObserver(update);
      const block=this.form.querySelector('[data-update-block="variant-id-main"]');
      if(block)this.observer.observe(block,{childList:true,subtree:true,attributes:true});
      this.update();
    }
    disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();}
    listText(){
      const lines=Array.from(this.querySelectorAll('[data-track-shopping-lines] > li'),row=>row.innerText.trim().replace(/\n+/g,' | '));
      const canonical=document.querySelector('link[rel="canonical"]')?.href||location.origin+location.pathname;
      return [this.querySelector('h3')?.textContent.trim(),...lines,this.querySelector('.nl-track-shopping-total')?.innerText.trim().replace(/\n+/g,' '),this.querySelector('.nl-track-shopping-price-note')?.textContent.trim(),canonical].filter(Boolean).join('\n\n');
    }
    async listAction(action){
      this.update();
      if(!this.querySelector('[data-track-list-error]')?.hidden)return;
      const status=this.querySelector('[data-track-list-action-status]');
      try{
        const text=this.listText();
        if(action==='copy'){
          if(!navigator.clipboard?.writeText)throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(text);
          status.textContent=this.dataset.copySuccess;status.hidden=false;
        }else if(action==='share'&&typeof navigator.share==='function'){
          await navigator.share({title:document.title,text});
        }else if(action==='print'){
          document.querySelector('[data-nl-track-print-root]')?.remove();
          const root=document.createElement('div');root.dataset.nlTrackPrintRoot='';
          const copy=document.createElement('section');copy.className='nl-track-shopping-list';
          for(const child of this.children){
            if(child.matches('script,[data-track-list-actions],[data-track-list-action-status],[data-track-list-error]'))continue;
            copy.append(child.cloneNode(true));
          }
          const url=document.createElement('p');url.className='nl-track-print-url';
          url.textContent=document.querySelector('link[rel="canonical"]')?.href||location.origin+location.pathname;
          root.append(copy,url);document.body.append(root);document.body.dataset.nlTrackPrint='';
          const clean=()=>{root.remove();delete document.body.dataset.nlTrackPrint;};
          addEventListener('afterprint',clean,{once:true});
          try{window.print();}catch(error){clean();throw error;}
        }
      }catch(error){
        if(error.name==='AbortError')return;
        status.textContent=this.dataset.actionError;status.hidden=false;
      }
    }

    update(){
      const mainId=this.form.querySelector('[name="id"]')?.value;
      const main=this.main.variants.find(v=>String(v.id)===String(mainId));
      if(!main){this.hidden=true;return;}
      this.hidden=false;
      const quantity=Number(this.form.querySelector('[name="quantity"]')?.value||1);
      let valid=Number.isSafeInteger(quantity)&&quantity>0;
      const lines=new Map();
      const kinds=new Set();
      if(this.dataset.mainKind==='rail')kinds.add('rail');
      if(['spot','pendant'].includes(this.dataset.mainKind))kinds.add('light');
      const sku=main.sku||'';
      // Exact existing component SKUs identify a main feed/end, without guessing from titles.
      if(/^R(1228[4-9]|1131[1-6]|1134[12])$/.test(sku))kinds.add('feed');
      if(/^R(1229[0-2]|1130[7-9]|11310)$/.test(sku))kinds.add('end');
      const add=(id,name,sku,price,qty,url)=>{
        if(!Number.isSafeInteger(qty)||qty<1||!Number.isFinite(price)||price<0){valid=false;return;}
        const key=String(id),old=lines.get(key);
        if(old)old.quantity+=qty;else lines.set(key,{name,sku,price,quantity:qty,url});
      };
      add(main.id,this.main.title,sku,main.price,quantity,null);
      this.form.querySelectorAll('nl4-track-choice').forEach(choice=>{
        if(choice.checkbox?.checked&&!choice.selectedItem)valid=false;
        const item=choice.selectedItem,opt=choice.select?.selectedOptions[0];
        if(!item||!opt||String(item.id)===String(main.id))return;
        add(item.id,opt.dataset.label||choice.querySelector('h3,h2')?.textContent||'',opt.dataset.sku||'',Number(opt.dataset.unitPrice),item.quantity,opt.dataset.url);
        const part=choice.dataset.part||'';
        if(part.startsWith('track'))kinds.add('rail');
        if(['feed','join_feed','continuous'].includes(part))kinds.add('feed');
        if(part.startsWith('end'))kinds.add('end');
        if(part==='spotlight'||choice.dataset.spotlightModel)kinds.add('light');
      });
      const bulb=this.form.querySelector('nl4-bulb-choice');
      if(bulb?.checkbox?.checked)add(bulb.dataset.bulbId,this.dataset.bulbName,'',Number(bulb.dataset.unitPrice),quantity*Number(bulb.dataset.bulbCount),bulb.querySelector('a[href]')?.href);
      const money=value=>new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency}).format(value/100);
      const list=this.querySelector('[data-track-shopping-lines]');list.replaceChildren();let total=0;
      for(const line of lines.values()){
        const row=document.createElement('li'),description=document.createElement('span');
        const label=line.url?document.createElement('a'):document.createElement('span');
        if(line.url)label.href=line.url;
        label.textContent=line.quantity+' × '+line.name;
        description.append(label);
        if(line.sku){const code=document.createElement('small');code.textContent=line.sku;description.append(code);}
        const price=document.createElement('strong');price.textContent=money(line.price*line.quantity);
        row.append(description,price);list.append(row);total+=line.price*line.quantity;
      }
      this.querySelector('[data-track-shopping-total]').textContent=valid?money(total):'—';
      const error=this.querySelector('[data-track-list-error]');error.hidden=valid;error.textContent=valid?'':this.dataset.invalid;
      this.querySelectorAll('[data-track-list-action]').forEach(button=>button.disabled=!valid);
      const actionStatus=this.querySelector('[data-track-list-action-status]');if(actionStatus){actionStatus.hidden=true;actionStatus.textContent='';}
      this.querySelectorAll('[data-track-check]').forEach(row=>{
        const included=kinds.has(row.dataset.trackCheck);row.dataset.included=String(included);
        row.querySelector('[data-track-check-status]').textContent=included?this.dataset.included:this.dataset.review;
      });
    }
  }
  customElements.define('nl-track-shopping-list',NLTrackShoppingList);
}
